import ConfirmModal from 'components/Modal/ConfirmModal';
import AutoSizedTextArea from 'components/inputs/AutoSizedTextArea';
import Select from 'components/inputs/Select';
import React, { useState } from 'react';
import styled from 'styled-components';

const StyledSelect = styled(Select)`
  margin-top: 10px;
  width: 100%;
`;

const StyledAutoSizedTextArea = styled(AutoSizedTextArea)`
  margin-top: 10px;
  min-height: 100px;
  width: 100%;
`;

const OTHER_REASON = 'Annat';

// Orsaken skrivs först i händelsetexten ("Lastbil tog: kommentar"). Nyckeltalet för avslag
// per anledning läser den därifrån, så listan måste hållas i takt med
// OperationsKpiLogic.DenyReasons.
const denyReasons = [
  'Lastbil tog',
  'Stopp butik',
  'Tilldelning butik klar',
  OTHER_REASON,
];

interface Props {
  onCancel: () => void;
  onConfirm: (message: string) => Promise<void>;
}

const ConfirmDenyAssignmentRequestModal: React.FC<Props> = ({
  onConfirm,
  onCancel,
}) => {
  const [reason, setReason] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  // Modalen ligger i modalstacken och får inte mutationens isLoading som prop, så
  // dubbelklick spärras här.
  const [isSubmitting, setIsSubmitting] = useState(false);

  const trimmedMessage = message.trim();
  const isValid =
    !!reason && (reason !== OTHER_REASON || trimmedMessage.length > 0);

  const buildEventMessage = () => {
    if (reason === OTHER_REASON) {
      return trimmedMessage;
    }
    return trimmedMessage ? `${reason}: ${trimmedMessage}` : reason;
  };

  return (
    <ConfirmModal
      title="Bekräfta avslå förfrågan"
      onCancel={onCancel}
      content="Är du säker på att du vill avslå förfrågan?"
      disabled={!isValid || isSubmitting}
      onConfirm={async () => {
        setIsSubmitting(true);
        try {
          await onConfirm(buildEventMessage());
        } catch {
          // Felet visas av den globala onError-hanteraren (App.tsx); låt användaren försöka igen.
          setIsSubmitting(false);
        }
      }}
    >
      <StyledSelect
        value={reason}
        onChange={(eve) => setReason(eve.currentTarget.value)}
      >
        <option value="" disabled>
          Välj anledning
        </option>
        {denyReasons.map((denyReason) => (
          <option key={denyReason} value={denyReason}>
            {denyReason}
          </option>
        ))}
      </StyledSelect>
      <StyledAutoSizedTextArea
        placeholder={
          reason === OTHER_REASON ? 'Ange anledning' : 'Kommentar (valfritt)'
        }
        value={message}
        onChange={(eve) => setMessage(eve.currentTarget.value)}
      />
    </ConfirmModal>
  );
};

export default ConfirmDenyAssignmentRequestModal;
